import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const SktContentActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

SktContentActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

SktContentActions.defaultProps = {
  basePath: '',
  data: {},
};

export default SktContentActions;
